define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerStatusModel = /** @class */ (function () {
        function CustomerStatusModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerStatusModel.Mapping, self);
            }
        }
        CustomerStatusModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerStatusModel(options.data);
            }
        };
        return CustomerStatusModel;
    }());
    return CustomerStatusModel;
});
//# sourceMappingURL=CustomerStatusModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerStatusModel.js
// module id = 227
// module chunks = 2